<div class="wrapper" (click)="onShowDetails()">
  <div class="titleContainer">
    <tun-scrollable-text class="title" [text]="searchMusicChannel.name"></tun-scrollable-text>
  </div>
</div>
